import type { ReactNode } from "react";
import { Check } from "lucide-react";

import styles from "./_trust.module.css";

export function Trust({
  label,
  body,
  children,
}: {
  label: string;
  body?: string;
  children?: ReactNode;
}) {
  return (
    <div className={styles.row}>
      <div className={styles.markSlot}>
        <div className={styles.mark}>
          <Check strokeWidth={3} />
        </div>
      </div>
      <div className={styles.text}>
        <h3 className={styles.label}>{label}</h3>
        <p className={styles.body}>{children ?? body}</p>
      </div>
    </div>
  );
}
